import React from "react";
import withShipment from "../../../withShipment";
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './Calendar.css'

//styling

// constants
import {
    BACK, TRANSACTION_CALENDAR_PAGE_NAME,
} from "./constants";

// custom components
import ErrorFeedbackBar from "../../global/ErrorFeedbackBar";
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";

import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import PropTypes from "prop-types";
import {
  allCarrierInvoicesCalendarSelector, allFTLInvoicesCalendarSelector, isLoadingSelector,
} from '../../../redux/selectors/invoices';
import {connect} from "react-redux";
import {setClickedDateEvents} from "../../../redux/actions/accounting/calendarActions";
import CarrierInvoiceDetail from './CarrierInvoiceDetail';
import { HourglassEmptyTwoTone, Restore } from '@material-ui/icons';
import { getAllCarrierInvoicesCalendar, getFTLInvoicesCalendar } from '../../../redux/actions/invoices';

const CustomToolbar = ({ label, onNavigate, onView, selectedMonth, selectedYear, setSelectedMonthYear }) => {


    const months = moment.months();

    const handlePrev = () => {
        let newMonth = selectedMonth - 1;
        let newYear = selectedYear;
        if (newMonth < 0) {
            newMonth = 11;
            newYear -= 1;
        }
        setSelectedMonthYear(newMonth, newYear);
    };

    const handleNext = () => {
        let newMonth = selectedMonth + 1;
        let newYear = selectedYear;
        if (newMonth > 11) {
            newMonth = 0;
            newYear += 1;
        }
        setSelectedMonthYear(newMonth, newYear);
    };

    const handleChangeMonth = (e) => {
        const selectedMonthIndex = parseInt(e.target.value);
        setSelectedMonthYear(selectedMonthIndex, selectedYear);
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: 16 }}>
            <div></div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <button
                    style={{ marginRight: 8, background: 'none', border: 'none', cursor: 'pointer' }}
                    onClick={handlePrev}
                >
                    <ChevronLeftIcon />
                </button>
                <select
                    style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc', marginRight: 8 }}
                    value={selectedMonth}
                    onChange={handleChangeMonth}
                >
                    {months.map((month, index) => (
                        <option key={index} value={index}>{month} {selectedYear}</option>
                    ))}
                </select>
                <button
                    style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                    onClick={handleNext}
                >
                    <ChevronRightIcon />
                </button>
            </div>
            <div></div>
        </div>
    );
};

class CarrierCalendar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            events: [],
            invoicesListFTL: null,
            invoicesListCarrier: null,
            selectedMonth: moment().month(),
            selectedYear: moment().year(),
            isCalendarInvoice:false,
            fetchedMonths: {}
        }
    }

    componentDidMount() {
         this.fetchCurrentMonthInvoices();
    }

    componentDidUpdate(prevProps, prevState) {

        const { selectedMonth, selectedYear } = this.state;
        const monthKey = `${selectedYear}-${selectedMonth}`;

        // Fetch invoices if this month is not fetched yet
        if (!this.state.fetchedMonths[monthKey]) {
            this.fetchCurrentMonthInvoices();
        }

         if ((prevProps.allInvoicesFTLCalendar !== this.props.allInvoicesFTLCalendar && this.props.allInvoicesFTLCalendar.length) || (prevProps.allInvoicesCarrierCalendar !== this.props.allInvoicesCarrierCalendar && this.props.allInvoicesCarrierCalendar.length)) {
                this.updateEvents();
         }

    }

    fetchCurrentMonthInvoices = () => {
            const { selectedMonth, selectedYear } = this.state;
            const {  getFTLInvoicesCalendar, getAllCarrierInvoicesCalendar,carrierType } = this.props;

            const startOfMonth = moment([selectedYear, selectedMonth]).startOf('month').toDate();
            const endOfMonth = moment([selectedYear, selectedMonth]).endOf('month').toDate();
            const monthKey = `${selectedYear}-${selectedMonth}`;

            if (this.state.fetchedMonths[monthKey]) return;

              if (carrierType === "Standard Carrier") {
                    getAllCarrierInvoicesCalendar({ fromDate: startOfMonth, toDate: endOfMonth });
                } else {
                    getFTLInvoicesCalendar({ fromDate: startOfMonth, toDate: endOfMonth });
                }

            this.setState(prevState => ({
                fetchedMonths: { ...prevState.fetchedMonths, [monthKey]: true }
            }));
    };

    updateEvents = () => {
        const { allInvoicesFTLCalendar, allInvoicesCarrierCalendar, carrierType } = this.props;
         const { events: existingEvents } = this.state;

        const newEvents = carrierType === "Standard Carrier" ? allInvoicesCarrierCalendar : allInvoicesFTLCalendar;

        const mergedEvents = [...existingEvents];
        newEvents.forEach(e => {
             if (!mergedEvents.find(ev => ev.data.invoiceNumber === e.data.invoiceNumber)) {
                mergedEvents.push(e);
            }
        });

        this.setState({ events: mergedEvents });

    }

    handleBack = (bool) =>{
        this.setState({isCalendarInvoice: bool})
    }

    setSelectedMonthYear = (month, year) => {
        this.setState({ selectedMonth: month, selectedYear: year });
    };

    handleDateClick = (clickedDate) => {
        const { events } = this.state;
        const eventsOnClickedDate = events.filter(event => moment(event.start).isSame(clickedDate, 'day'))
        this.props.setClickedDateEvents(eventsOnClickedDate);
        this.setState({isCalendarInvoice: true})
    }

    displayInvoice = () => {
        return (
          <CarrierInvoiceDetail
            handleBack={this.handleBack}
            bankAccounts={this.props.bankAccounts}
          />
        )
    }

    render() {

        const {events, selectedMonth, selectedYear} = this.state;

        return (
            <>

                <ErrorFeedbackBar />

                {!this.state.isCalendarInvoice &&
                  <TopToolbar
                      pageName={TRANSACTION_CALENDAR_PAGE_NAME}
                      menuItems={[
                        {
                          title: BACK,
                          icon: <KeyboardBackspaceIcon />,
                          onClick: () => {
                            this.props.handlePreview(false)
                          }
                        },
                        ...(this.props.isLoading
                          ? [{
                              icon: <HourglassEmptyTwoTone />,
                              disabled: true,
                              title: "Loading..."
                            }]
                          : [])
                      ]}
                    />
                }


                {this.state.isCalendarInvoice ?  this.displayInvoice():
                  <div style={{ height: "95vh" }}>
                      <Calendar
                        localizer={momentLocalizer(moment)}
                        events={events}
                        views={["month"]}
                        components={{
                            toolbar: (props) => (
                                <CustomToolbar
                                        {...props}
                                        selectedMonth={selectedMonth}
                                        selectedYear={selectedYear}
                                        setSelectedMonthYear={this.setSelectedMonthYear}
                                  />
                              // <CustomToolbar
                              //   {...props}
                              //   label={moment.months()[selectedMonth]}
                              //   selectedMonth={selectedMonth}
                              //   selectedYear={selectedYear}
                              //   setSelectedMonth={selectedMonth => this.setState({ selectedMonth })}
                              //   setSelectedYear={selectedYear => this.setState({ selectedYear })}
                              // />
                            ),
                            event: ({ event }) => {
                                let background;
                                let color;

                                switch (event.data.status) {
                                    case "Approved for Payment":
                                        background = "#FFD966"
                                        color = "black"
                                        break;
                                    case "Paid":
                                        background = "#b0d484";
                                        color = "black"
                                        break;
                                    case "Needs Review":
                                        background = "#FF4F4B";
                                        color = "white"
                                        break;
                                    default:
                                        background = "white";
                                        color = "black"
                                        break;
                                }

                                return (
                                  <div key={event.id} style={{ margin: 2 }}>
                                      <div style={{
                                          background: background,
                                          color: color,
                                          fontWeight: "bold",
                                          fontSize: 14,
                                          paddingLeft: 8,
                                          paddingRight: 8
                                      }}>
                                          {event.data.description}
                                      </div>
                                  </div>
                                );
                            }
                        }}
                        date={new Date(selectedYear, selectedMonth)}
                        onSelectEvent={(event) => this.handleDateClick(moment(event.start))}
                        onNavigate={(date, view) => {
                            // Handle navigation logic here
                        }}

                      />
                  </div>
                }
            </>
        );
    }
}

const actionCreators = {
    getAllCarrierInvoicesCalendar,
    getFTLInvoicesCalendar
};

const mapStateToProps = (state) => ({
    allInvoicesCarrierCalendar: allCarrierInvoicesCalendarSelector(state),
    allInvoicesFTLCalendar: allFTLInvoicesCalendarSelector(state),
    isLoading: isLoadingSelector(state)
});

CarrierCalendar.propTypes = {
    allInvoicesFTLCalendar: PropTypes.array,
    allInvoicesCarrierCalendar: PropTypes.array,
};

CarrierCalendar.defaultProps = {
    allInvoicesFTLCalendar: [],
    allInvoicesCarrierCalendar: [],
};
const mapDispatchToProps = {
    setClickedDateEvents,
};

export default withShipment({
    mapStateToProps,
    actionCreators
}, connect(mapStateToProps, mapDispatchToProps)(CarrierCalendar));






